import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import type GoalConfig from 'modules/goals/store/models/GoalConfig'

interface TableActionsProps {
  onClick: () => void
  goalConfig: GoalConfig
  showActions?: boolean
}

const Actions = ({ onClick, goalConfig, showActions = false }: TableActionsProps) => {
  if (goalConfig.isFinished || !showActions) return null

  if (!users.current.policy.can('apiCore.accessGoalsConfigCreate')) return null

  return (
    <Box>
      <Button type="secondary" onClick={onClick} iconName="add">
        {i18n.t('surveys.goals.show.table.add_employees')}
      </Button>
    </Box>
  )
}

export default observer(Actions)
